export const PRODUCT_FAMILIES = [
  'Brownie Cookie Sandwich',
  'Massive Stuffed Cookie',
  'Brownie',
] as const

export type ProductFamily = typeof PRODUCT_FAMILIES[number]
export type PublicProductType = 'Brownie Cookie Sandwich' | 'Stuffed Cookie' | 'Brownie'

export function isProductFamily(value: unknown): value is ProductFamily {
  return typeof value === 'string' && (PRODUCT_FAMILIES as readonly string[]).includes(value)
}

export function publicProductTypeForFamily(family: ProductFamily): PublicProductType {
  if (family === 'Massive Stuffed Cookie') return 'Stuffed Cookie'
  if (family === 'Brownie') return 'Brownie'
  return 'Brownie Cookie Sandwich'
}
